import { RIGState, RIGAction, RIGActions } from "./RIG.state";

// ✅ RIG utils reducer logic
export const RIGReducer = (state: RIGState, action: RIGAction): RIGState => {
    switch (action.type) {
        case RIGActions.SET_DISCLOSURE_RIGS:
            return { ...state, disclosureGuides: action.payload };

        case RIGActions.SET_TOPIC_RIGS:
            return { ...state, topicGuides: action.payload };

        default:
            return state;
    }
};
